import React, { useState } from 'react'
import { Box, Tooltip } from '@chakra-ui/core'
import { Grid, List } from 'lucide-react'
import { NoFocusButton } from 'components/CommonComponents/NoFocusButton'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'

interface ViewModeSwitchProps {
  onViewModeChange?: (isGridView: boolean) => void
  viewMode: 'grid' | 'table'
}

export const ViewModeSwitch: React.FC<ViewModeSwitchProps> = ({ onViewModeChange, viewMode }) => {
  const [isGridView, setIsGridView] = useState(viewMode === 'grid')
  const theme = useSelector((state: RootState) => state.general.theme)

  const handleViewChange = (gridView: boolean) => {
    setIsGridView(gridView)
    onViewModeChange?.(gridView)
  }

  return (
    <Box
      display="flex"
      backgroundColor="white"
      borderRadius="md"
      border="1px solid #E2E8F0"
      overflow="hidden"
      width="fit-content"
    >
      <Tooltip label="Grid view" placement="bottom" hasArrow aria-label="Grid view" zIndex={10000}>
        <NoFocusButton
          aria-label="Grid view"
          size="sm"
          onClick={() => handleViewChange(true)}
          backgroundColor={isGridView ? theme?.elementsColor : 'white'}
          color={isGridView ? 'white' : theme?.elementsColor}
          borderRadius={isGridView ? 'md 0 0 md' : 'md'}
          flex="1"
          height="36px"
          minW="36px"
          p="0"
          _hover={{ opacity: 0.8 }}
        >
          <Grid size={18} />
        </NoFocusButton>
      </Tooltip>
      <Tooltip label="List view" placement="bottom" hasArrow aria-label="List view" zIndex={10000}>
        <NoFocusButton
          aria-label="List view"
          size="sm"
          onClick={() => handleViewChange(false)}
          backgroundColor={!isGridView ? theme?.elementsColor : 'white'}
          color={!isGridView ? 'white' : theme?.elementsColor}
          borderRadius={!isGridView ? '0 md md 0' : 'md'}
          flex="1"
          height="36px"
          minW="36px"
          p="0"
          _hover={{ opacity: 0.8 }}
        >
          <List size={18} />
        </NoFocusButton>
      </Tooltip>
    </Box>
  )
}
